

import cartsJson from '../../json/carts.json'

export default {
  /***** All carts items ***/
  items: cartsJson
}



// WEBPACK FOOTER //
// ./src/store/carts/state.js